export default "__VITE_ASSET__CWEnvojV__"